import { Button, Card, Form, notification } from 'antd'
import { BillingFormElements } from './billing-form-elements'
import React from 'react'
import { useAuth } from '../../auth'
import { useTranslation } from 'react-i18next'
import useForm from '../../hooks/use-form'
import { useUpdateCompany } from '../../company/hooks'

export function UpdateBillingCard() {
    const { t } = useTranslation()
    const { activeCompany } = useAuth()
    const updateCompanyMutation = useUpdateCompany(activeCompany?.id)

    const formProps = useForm({
        mutation: updateCompanyMutation,
        onSuccess: () => {
            notification.success({
                message: t('{{name}} updated', { name: t('Billing information') }),
            })
        },
    })

    return (
        <Card className="w-full">
            <Form
                {...formProps}
                initialValues={activeCompany!}
                layout="vertical"
            >
                <BillingFormElements />
                <Button
                    htmlType="submit"
                    loading={updateCompanyMutation.isPending}
                >
                    {t('Update')}
                </Button>
            </Form>
        </Card>
    )
}
